import type { SingleProductTabButtons } from '../types/product';

export const MAX_COMPARE_LIST_SIZE = 4;

export const singleProductTabButtons: SingleProductTabButtons[] = [
  { label: 'فروشندگان اینترنتی', value: 'online-shops' },
  { label: 'فروشندگان حضوری', value: 'physical-shops' },
];
